import { Header, Footer } from '@/components/layout'
import { Hero, Products, BlogInstagram, Concept, Access } from '@/components/sections'
import { PageTopButton } from '@/components/ui'

function App() {
  return (
    <>
      <Header />

      <main>
        <Hero />
        <Products />
        <BlogInstagram />
        <Concept />
        <Access />
      </main>

      <Footer />
      <PageTopButton />
    </>
  )
}

export default App
